import styled from '@emotion/styled';

const StepsSection = styled.section`
  background-color: #8639ec;
  @media (max-width: 768px) {
    background-color: #8940fa;
  }
`;

const StepsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 926px;
  width: 100%;
  margin: auto;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-gap: 16px;
    padding: 0 16px 16px 16px;
  }
`;

const StepContainer = styled.div`
  text-align: center;
  padding: 36px 16px;
  @media (max-width: 768px) {
    background-color: #8639ec;
    border-radius: 6px;
  }
`;

const IconWrapper = styled.div<{ padding: number }>`
  border-radius: 100%;
  background-color: #8940fa;
  width: 56px;
  padding: ${({ padding }) => `${padding}px`};
  margin: auto;
`;

const StepHeader = styled.h4`
  color: #fff;
  text-transform: uppercase;
  font-size: 1.4rem;
  padding: 16px 0 4px 0;
  margin: 0;
`;

const StepText = styled.p`
  color: #ebeced;
  font-size: 1.6rem;
`;

export {
  StepsSection,
  StepsContainer,
  StepContainer,
  IconWrapper,
  StepHeader,
  StepText,
};
